import { Flex } from "../../flex";

import * as RedoTypingCss from "./redo-typing.module.css";

export function RedoTyping() {
  return (
    <Flex
      className={RedoTypingCss.wave}
      gap="xs"
      justify="flex-start"
      textAlign="left"
    >
      <span className={RedoTypingCss.dot} />
      <span className={RedoTypingCss.dot} />
      <span className={RedoTypingCss.dot} />
    </Flex>
  );
}
